'use strict';

var _toConsumableArray = require("/home/chaunguyen/projects/yacoin/yaswap/liquality-swap/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var varuint = require('../varint');

var bip32Derivation = require('./bip32Derivation');

var isValidBIP340Key = function isValidBIP340Key(pubkey) {
  return pubkey.length === 32;
};

function makeConverter(TYPE_BYTE) {
  var parent = bip32Derivation.makeConverter(TYPE_BYTE, isValidBIP340Key);

  function decode(keyVal) {
    var nHashes = varuint.decode(keyVal.value);
    var nHashesLen = varuint.encodingLength(nHashes);
    var base = parent.decode({
      key: keyVal.key,
      value: keyVal.value.slice(nHashesLen + nHashes * 32)
    });
    var leafHashes = new Array(nHashes);

    for (var i = 0, _offset = nHashesLen; i < nHashes; i++, _offset += 32) {
      leafHashes[i] = keyVal.value.slice(_offset, _offset + 32);
    }

    return Object.assign({}, base, {
      leafHashes: leafHashes
    });
  }

  function encode(data) {
    var base = parent.encode(data);
    var nHashesLen = varuint.encodingLength(data.leafHashes.length);
    var nHashesBuf = Buffer.allocUnsafe(nHashesLen);
    varuint.encode(data.leafHashes.length, nHashesBuf);
    var value = Buffer.concat([nHashesBuf].concat(_toConsumableArray(data.leafHashes), [base.value]));
    return Object.assign({}, base, {
      value: value
    });
  }

  var expected = '{ ' + 'masterFingerprint: Buffer; ' + 'pubkey: Buffer; ' + 'path: string; ' + 'leafHashes: Buffer[]; ' + '}';

  function check(data) {
    return Array.isArray(data.leafHashes) && data.leafHashes.every(function (leafHash) {
      return Buffer.isBuffer(leafHash) && leafHash.length === 32;
    }) && parent.check(data);
  }

  return {
    decode: decode,
    encode: encode,
    check: check,
    expected: expected,
    canAddToArray: parent.canAddToArray
  };
}

exports.makeConverter = makeConverter;